import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ItemList from "../components/ItemList.jsx";

function createMarkup(htmlstring) { return {__html: htmlstring}; }

export default class BookCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  renderPeopleList(people, label) {
    return (<div className="digest-card__items">
        <span className="digest-card__label">
          { label } -&nbsp;
        </span>
        { people.map((person, i) => {
          let spacer = i < people.length - 2
            ? ", "
            : i === people.length - 2
              ? " & "
              : "";
          return <span key={i} dangerouslySetInnerHTML={{ __html: person + spacer }}></span>;
        }) }
      </div>);
  }

  render() {
    const { abstract, authors, displaytypename, editors, imageurl, lecturetypename, presenters, publisheddate, displaydate, summer, title, type, url, videoimageurl, issueNum, dateFormat, producerlabel, certifiedrandom } = this.props;

    const ariaLabel = "Read the full article on " + title;
    const producer_label = (producerlabel != null) ? producerlabel : "Editor(s)";

    const cardClass = classNames("digest-card", {
      "has-video": videoimageurl && videoimageurl.length > 0
    });

    const listOptions = {
      "last_item_symbol": certifiedrandom ? "ⓡ" : "&",
      "item_concatenator": ","
    };

    return (
      <div className={cardClass}>
        { imageurl && <img className="digest-card__image" src={ imageurl } alt="" />}
        { videoimageurl && <div className="digest-card__video-wrapper">
            <img className="digest-card__image" src={ videoimageurl } alt="" />
          </div> }
        { title && <div className="digest-card__title"><a ref={el => (this.itemWrapper = el)} href={ url }>{ title }</a></div>}
        { (displaydate || displaytypename ) && <div className="digest-card__date">
          { issueNum && <span className="digest-card__label">
              ISSUE: No. { issueNum },&nbsp;
            </span> }
          { displaydate && <span className="digest-card__label">
              { displaydate }
            </span> }
            { displaydate && displaytypename && <span> - </span>}
            { displaytypename && <span className="digest-card__label" dangerouslySetInnerHTML={ createMarkup(displaytypename) } />}
          </div> }
        { lecturetypename && <div className="digest-card__items">
            <span className="digest-card__label">Lecture - </span> {lecturetypename}
          </div> }
        { authors && authors.length > 0 && <ItemList items={authors} options={listOptions} label="Author(s)" showMoreButton={authors.length > 9} /> }
        { editors && editors.length > 0 && <ItemList items={editors} options={listOptions} label={producer_label} /> }
        { presenters && presenters.length > 0 && <ItemList items={presenters} label="Presenter(s)" /> }
        {/* @todo: figure out what 'summer' is, and make it work like ItemList */}
        { summer && summer.length > 0 && this.renderPeopleList(summer.map( s => ({ "name": s.title, "uri": s.url, "shouldLink": true })), "Associated Conference") }
        { abstract && <div className="digest-card__summary">{ abstract }...</div>}
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

BookCard.propTypes= {
  abstract: string,
  authors: array,
  editors: array,
  displaytypename: string,
  index: number,
  imageurl: string,
  lecturetypename: string,
  loading: bool,
  presenters: array,
  publisheddate: string,
  displaydate: string,
  summer: array,
  title: string,
  type: string,
  url: string,
  videoimageurl: string,
  dateFormat: string,
  issueNum: number,
  producerlabel: string,
  certifiedrandom: bool
};

BookCard.defaultProps = {
  certifiedrandom: false
};